import * as yup from 'yup';
export const RegisterSchema = yup.object().shape({
  name: yup
    .string()
    .required('Введите имя пользователя')
    .min(4, 'Имя пользователя не может быть короче 6 символов')
    .max(20, 'Имя пользователя не должно превышать 20 символов'),
  email: yup
    .string()
    .email('Неверный адрес электронной почты')
    .required('Введите адрес электронной почты'),
  password: yup
    .string()
    .required('Введите пароль')
    .min(6, 'Пароль не может быть короче 6 символов'),
});

export const LoginSchema = yup.object().shape({
  email: yup
    .string()
    .email('Неверный адрес электронной почты')
    .required('Введите адрес электронной почты'),
  password: yup
    .string()
    .required('Введите пароль')
    .min(6, 'Пароль не может быть короче 6 символов'),
});
